import {ComponentData, Entity} from "../../engine/tools/EntityManager";

export class PumpToInput implements ComponentData {

    pumpEntity: Entity
    multiplier: number = 1

    constructor(options?: Partial<PumpToInput>) {
        Object.assign(this, options)
    }
}

